import React from 'react';
import { datetimeFromUTC } from 'utils/dayjs';
import bem from 'utils/bem';
import Icon from 'components/Icon';
import FormError from 'forms/fields/FormError';

import './index.sass'
import Spinner from 'components/Spinner';

const { cnBlock, el } = bem('common-datetime-input');

const CommonDateTimeInput = ({ className, value = '', error, onClick, loading, ...rest }) => {

    const { date, time } = datetimeFromUTC(value)
    const inputValue = value ? `${date} ${time}` : ''

    return (
        <div className={ el('container', { 'active': value !== '', 'disabled': loading}) } onClick={onClick} >
            <input {...rest} className={ cnBlock(className) } value={ inputValue } disabled />
            {loading && <Spinner />}
            {!loading && <Icon name={ 'calendar-blank' }/>}
            { error && <FormError/> }
        </div>
    )
}

export default CommonDateTimeInput;
